// extracted by mini-css-extract-plugin
export default {"radio":"Radio--radio--kaX8U"};